// extracted by css-extract-rspack-plugin
export default {"backToTop":"_ccdd328f","isVisible":"_ccb8160","positionAboveChat":"_25bb1c8c","caret":"_3be17795","caretWithCopy":"_a26560f2","caretWithoutCopy":"_4a7697bc","top":"_f4d743bf"};